import Vue from "vue";
import {
  RunConfigService,
  ConfigService,
  ShoppingContext
} from "@nuskin/ns-util";
import debounce from "lodash/debounce";

import vueEventBus from "../components/EventBus";

const newEl = document.createElement("div");
newEl.id = "ns-app-service";
const serviceEl = document.body.appendChild(newEl);

const NsAppService = new Vue({
  name: "NsAppService",
  data() {
    return {
      runConfig: {},
      runConfigInterval: null,
      runConfigTries: 3,
      locale: "",
      marketConfig: {},
      awsUrl: "",
      siteUrl: "",
      loading: true
    };
  },
  computed: {
    isStorefront() {
      const veraData =
        JSON.parse(localStorage.getItem("skin-consultation-vuex-state")) || {};
      const isCorporateSponsor =
        veraData.app && veraData.app.isCorporateSponsor;

      return (
        !isCorporateSponsor &&
        (ShoppingContext.isContext(ShoppingContext.STOREFRONT) ||
          ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT) ||
          ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER) ||
          ShoppingContext.isContext(ShoppingContext.PRODUCT_OFFER))
      );
    }
  },
  async mounted() {
    await this.setConfig();

    this.runConfigInterval = setInterval(async () => {
      if (this.runConfigTries <= 0) {
        clearInterval(this.runConfigInterval);
        this.runConfigTries = 0;
      } else {
        await this.checkConfig();
        this.runConfigTries--;
      }
    }, 350);
  },
  beforeDestroy() {
    clearInterval(this.runConfigInterval);
  },
  methods: {
    /**
     * Checks app and market config if current
     */
    checkConfig: debounce(async function(runConfig) {
      runConfig = runConfig || RunConfigService.getRunConfig() || {};
      if (
        !!runConfig.language &&
        !!runConfig.country &&
        (runConfig.language !== this.runConfig.language ||
          runConfig.country !== this.runConfig.country)
      ) {
        await this.setConfig(runConfig);
      }
    }, 250),

    /**
     * Set app and market config, along with associated variables
     */
    async setConfig(runConfig) {
      runConfig = runConfig || RunConfigService.getRunConfig() || {};
      if (!runConfig.language || !runConfig.country) {
        // the runconfig isn't ready yet
        return;
      }

      this.runConfig = runConfig;
      this.locale = `${this.runConfig.language}_${this.runConfig.country}`;

      this.marketConfig = ConfigService.getMarketConfig();
      if (this.marketConfig) {
        this.awsUrl = this.marketConfig.awsUrl;
        this.siteUrl = this.marketConfig.siteUrl;
      } else {
        this.awsUrl = null;
        this.siteUrl = null;
      }

      this.loading = false;

      const configData = {
        runConfig: this.runConfig,
        marketConfig: this.marketConfig,
        isStorefront: this.isStorefront
      };

      // this.$emit/this.$NsAppService.$on wasn't being consumed properly
      vueEventBus.$emit("config-changed", configData);
    }
  }
}).$mount(serviceEl);

Vue.prototype.$NsAppService = NsAppService;

export default NsAppService;
